import React, { useState, useEffect } from "react";

import Header from "../Header";

import Sidebar from "../Sidebar";

import Footer from "../Footer";

import { useParams, Link } from "react-router-dom";

import { isMobile } from "react-device-detect";

import Auth from "../../Auth";

import Setup from "../Setup";

import Chart from "react-apexcharts";

import { useSelector } from "react-redux";

import axios from "axios";

const Home = () => {
    const { id } = useParams();

    const user = useSelector((state) => state.user.data);
    
      const phone = user?.phone;
      const email = user?.email;
      const username = user?.username;
      const studid = user?.stud_id;
    const studclass = user?.studclass;


    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 1,
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1,
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1,
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
        },
    };

    var height = parseInt("100");
    var labelColor = "#2d3436";
    var borderColor = "#fff";
    var baseColor = "#2c4f40";
    var lightColor = "#000";

    const config_ = {
        series: [
            {
                name: "Notes",
                data: [5, 6, 9],
            },
        ],
        options: {
            chart: {
                fontFamily: "inherit",
                type: "area",
                height: height,
                toolbar: {
                    show: false,
                },
            },
            plotOptions: {},
            legend: {
                show: false,
            },
            dataLabels: {
                enabled: false,
            },
            fill: {
                type: "solid",
                opacity: 4,
            },
            stroke: {
                curve: "smooth",
                show: true,
                width: 3,
                colors: [baseColor],
            },
            xaxis: {
                categories: ["Mathematics", "English Language", "Physics"],
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
                labels: {
                    style: {
                        colors: "#000",
                        fontSize: "12px",
                    },
                },
                crosshairs: {
                    position: "front",
                    stroke: {
                        color: baseColor,
                        width: 1,
                        dashArray: 3,
                    },
                },
                tooltip: {
                    enabled: true,
                    formatter: undefined,
                    offsetY: 0,
                    style: {
                        fontSize: "12px",
                    },
                },
            },
            yaxis: {
                labels: {
                    style: {
                        colors: labelColor,
                        fontSize: "12px",
                    },
                },
            },
            states: {
                normal: {
                    filter: {
                        type: "none",
                        value: 0,
                    },
                },
                hover: {
                    filter: {
                        type: "none",
                        value: 0,
                    },
                },
                active: {
                    allowMultipleDataPointsSelection: false,
                    filter: {
                        type: "none",
                        value: 0,
                    },
                },
            },
            tooltip: {
                style: {
                    fontSize: "12px",
                },
                y: {
                    formatter: function (val) {
                        return "" + val + " Times";
                    },
                },
            },
            colors: [lightColor],
            grid: {
                borderColor: borderColor,
                strokeDashArray: 4,
                yaxis: {
                    lines: {
                        show: true,
                    },
                },
            },
            markers: {
                strokeColor: baseColor,
                strokeWidth: 3,
            },
        },
    };

    const [note_task, setNoteTask] = useState([]);

    const FetchNote = (search) => {

        axios({
            method: "post",
            url: "./v3/note/list/",
            data: {
                studclass,
                q: search
            },
            config: { headers: { "Content-Type": "multiport/form-data" } },
        })
            .then(function (response) {
                const view = response.data;

                setNoteTask(view);

            })
            .catch((err) => {
                // toast.error("Error: Request Failed! Refresh page..");
            });

    }

    return (
        <div>

            <Auth />

            <Header />

            <Sidebar />

            <div class="docs-wrapper bg-back">
                <div class="container-fluid px-3 px-lg-8 pt-lg-14 pt-4">

                  
                            <div className="row align-items-center">

                                <div className="col-6 mb-6 text-start">
                                    <div className="fs-3 text-purple2">
                                        Lecture |{" "}
                                        <span className="text-dark fs-5">
                                            ---- Notes
                                        </span>
                                    </div>
                                </div>

                                <div className="col-6 mb-6 text-end">
                                    <Link to={"../" + id + "/notemaker"} className="btn btn-purple btn-lg rounded-pill" >
                                        <i className="bi bi-app-indicator"></i> Note Maker
                                    </Link>
                                </div>

                                <div className="col-lg-7 mb-6">

                                    <div className="card py-6 px-6 shadow-none bg-purple2 opacity-75 mb-4" style={{ borderRadius: "25px" }}>
                                        <div className="row align-items-center placeholder-glow">
                                            <div className="text-purple3 fs-3 col-10">
                                                <i class="bi bi-folder2-open"></i> Read Class Note.
                                            </div>
                                            <div className="col-2">
                                                {isMobile ?
                                                    <div className="btn btn-white rounded-circle"
                                                        data-bs-toggle="offcanvas"
                                                        data-bs-target="#classNote"
                                                        aria-controls="offcanvasBottom"
                                                    >
                                                        <i class="bi bi-arrow-right fs-3"></i>
                                                    </div>
                                                    :
                                                    <div className="btn btn-white rounded-circle"
                                                        data-bs-toggle="offcanvas"
                                                        data-bs-target="#classNote"
                                                    >
                                                        <i class="bi bi-arrow-right fs-3"></i>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card py-6 px-6 shadow-none bg-orange_ opacity-75 mb-4" style={{ borderRadius: "25px" }}>
                                        <div className="row align-items-center placeholder-glow">
                                            <div className="text-white fs-3 col-10">
                                                <i class="bi bi-folder2-open"></i> Read My Note.
                                            </div>
                                            <div className="col-2">
                                                <div className="btn btn-white rounded-circle">
                                                    <i class="bi bi-arrow-right fs-3"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card py-6 px-6 shadow-none bg-dark opacity-75 mb-4" style={{ borderRadius: "25px" }}>
                                        <div className="row align-items-center placeholder-glow">
                                            <div className="text-white fs-3 col-10">
                                                <i class="bi bi-folder2-open"></i> Read Partner's Note.
                                            </div>
                                            <div className="col-2">
                                                {isMobile ?
                                                    <div className="btn btn-white rounded-circle"
                                                        data-bs-toggle="offcanvas"
                                                        data-bs-target="#offcanvasBottom"
                                                        aria-controls="offcanvasBottom"
                                                    >
                                                        <i class="bi bi-arrow-right fs-3"></i>
                                                    </div>
                                                    :
                                                    <div className="btn btn-white rounded-circle"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#ShareNote"
                                                    >
                                                        <i class="bi bi-arrow-right fs-3"></i>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>


                                </div>

                                <div className="col-lg-5">
                                    <div className="card shadow-none bg-white py-4 px-2 px-lg-3" style={{ borderRadius: "25px" }}>
                                        <div className="text-purple2 fs-3 mb-3">
                                            <i class="bi bi-graph-up-arrow"></i> Lecture Notes Activity
                                        </div>
                                        <Chart
                                            options={config_.options}
                                            series={config_.series}
                                            type="line"
                                            height={300}
                                        />

                                        <div className="text-purple2 fs-4 mb-3">
                                            Note; Graphical plot showing the number of times a subject was read according to the number of weeks
                                            uploaded.
                                        </div>

                                    </div>
                                </div>

                            </div>
                       
                    <Footer />
                </div>
            </div>

            {isMobile ? (
                <div
                    class="offcanvas offcanvas-bottom offcanvas-lg bg-white curve3"
                    tabindex="-1"
                    id="offcanvasBottom"
                    aria-labelledby="offcanvasBottomLabel"
                    style={{
                        height: "300px",
                        borderTopLeftRadius: "20px",
                        borderTopRightRadius: "20px",
                    }}
                >
                    <div class="offcanvas-header">
                        <div
                            class="offcanvas-title fs-t2 text-q2"
                            id="offcanvasBottomLabel"
                        ></div>

                        <button
                            class="btn btn-white btn-icon text-purple2"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                        >
                            <i class="bi bi-x-lg fw-bold fs-t"></i>
                        </button>
                    </div>
                    <div class="offcanvas-body py-0 px-4">

                        <div className="px-4 mb-4">
                            <div className="fs-t text-purple2">
                                Note Sharing
                            </div>

                            <form className="row mt-6">
                                <div class="col-10 mb-6">
                                    <input
                                        type="text"
                                        maxLength={10}
                                        id="name-input"
                                        autoComplete={false}
                                        name="admin"
                                        class="form-control form-control-lg text-dark fs-3 bg-back rounded-pill"
                                        placeholder="Enter Note Key"
                                        required

                                    />
                                </div>

                                <div className="col-2 mb-6">
                                    <button type='submit' className="btn btn-success btn-lg rounded-pill">
                                        <i class="bi bi-arrow-right"></i>
                                    </button>
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            ) : (
                <>
                    <div
                        class="modal"
                        id="ShareNote"
                        tabindex="-1"
                        role="dialog"
                        data-bs-backdrop="static"
                        aria-labelledby="exampleModalCenterTitle"
                        aria-hidden="true"
                    >
                        <div
                            class={
                                isMobile
                                    ? "modal-dialog modal-dialog-centered modal-fullscreen"
                                    : "modal-dialog modal-md modal-dialog-centered"
                            }
                            role="document"
                        >
                            <div
                                class="modal-content"
                                style={
                                    isMobile
                                        ? { border: "#fff" }
                                        : { borderRadius: "35px", border: "#fff" }
                                }
                            >
                                <div class="modal-header border-0 py-0">
                                    <div className="fs-t text-purple3"></div>

                                    <button
                                        class="btn btn-white btn-icon text-purple2 mt-5"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <i class="bi bi-x-lg fw-bold fs-4"></i>
                                    </button>
                                </div>
                                <div class="modal-body py-0">
                                    <div className="px-4 mb-6 mt-n4">
                                        <div className="fs-t text-purple2">
                                            Note Sharing
                                        </div>

                                        <form className="row mt-6">
                                            <div class="col-10 mb-6">
                                                <input
                                                    type="text"
                                                    maxLength={10}
                                                    id="name-input"
                                                    autoComplete={false}
                                                    name="admin"
                                                    class="form-control form-control-lg text-dark fs-3 bg-back rounded-pill"
                                                    placeholder="Enter Note Key"
                                                    required

                                                />
                                            </div>

                                            <div className="col-2 mb-6">
                                                <button type='submit' className="btn btn-success btn-lg rounded-pill">
                                                    <i class="bi bi-arrow-right"></i>
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}


            {isMobile ? (
                <div
                    class="offcanvas offcanvas-bottom offcanvas-lg bg-white"
                    tabindex="-1"
                    id="classNote"
                    aria-labelledby="offcanvasBottomLabel"
                    style={{
                        height: "800px",
                        borderTopLeftRadius: "20px",
                        borderTopRightRadius: "20px",
                    }}
                >
                    <div class="offcanvas-header">
                        <div className="fs-t text-primary">
                            All Class Note --- {studclass}
                        </div>

                        <button
                            class="btn btn-white btn-icon text-purple2"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                        >
                            <i class="bi bi-x-lg fw-bold fs-t"></i>
                        </button>
                    </div>
                    <div class="offcanvas-body py-0 px-4">

                        <form className="row mt-4 mb-6">
                            <div class="">
                                <input
                                    type="text"
                                    autoComplete={false}
                                    class="form-control form-control-lg text-dark fs-3 bg-back rounded-pill"
                                    placeholder="Search Reference"
                                    required

                                />
                            </div>
                        </form>

                        <div className="row">

                            <div className="col-12 mb-4">
                                <div className="card px-2 bg-back cursor-pointer shadow-none" style={{ borderRadius: "25px" }}>
                                    <div className="row d-flex align-items-center">
                                        <div className="col-4">
                                            <div className="fs-2 text-purple2 text-center">
                                                MTH
                                            </div>
                                        </div>

                                        <div className="col-8 p-4 bg-light-primary" style={{ borderRadius: "25px" }}>
                                            <div className="fs-5 text-purple2">
                                                Explore Mathematics notes with better user-interface, you can
                                                ask questions, attempt exercise, set quiz test.
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className="col-12 mb-4">
                                <div className="card px-2 bg-back cursor-pointer shadow-none" style={{ borderRadius: "25px" }}>
                                    <div className="row d-flex align-items-center">
                                        <div className="col-4">
                                            <div className="fs-2 text-purple2 text-center">
                                                ENG
                                            </div>
                                        </div>

                                        <div className="col-8 p-4 bg-light-success" style={{ borderRadius: "25px" }}>
                                            <div className="fs-5 text-purple2">
                                                Explore English notes with better user-interface, you can
                                                ask questions, attempt exercise, set quiz test.
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className="col-12 mb-4">
                                <div className="card px-2 bg-back cursor-pointer shadow-none" style={{ borderRadius: "25px" }}>
                                    <div className="row d-flex align-items-center">
                                        <div className="col-4">
                                            <div className="fs-2 text-purple2 text-center">
                                                PHY
                                            </div>
                                        </div>

                                        <div className="col-8 p-4 bg-light-info" style={{ borderRadius: "25px" }}>
                                            <div className="fs-5 text-purple2">
                                                Explore Physics notes with better user-interface, you can
                                                ask questions, attempt exercise, set quiz test.
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className="col-12 mb-4">
                                <div className="card px-2 bg-back cursor-pointer shadow-none" style={{ borderRadius: "25px" }}>
                                    <div className="row d-flex align-items-center">
                                        <div className="col-4">
                                            <div className="fs-2 text-purple2 text-center">
                                                CHM
                                            </div>
                                        </div>

                                        <div className="col-8 p-4 bg-light-primary" style={{ borderRadius: "25px" }}>
                                            <div className="fs-5 text-purple2">
                                                Explore Chemistry notes with better user-interface, you can
                                                ask questions, attempt exercise, set quiz test.
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            ) : (
                <>
                    <div
                        class="offcanvas offcanvas-end bg-white"
                        tabindex="-1"
                        id="classNote"
                        aria-labelledby="offcanvasRightLabel"
                    >
                        <div class="offcanvas-header">

                            <div className="fs-t text-dark-primary">
                                All Class Note --- {studclass}
                            </div>

                            <button
                                class="btn btn-white btn-icon text-purple3"
                                data-bs-dismiss="offcanvas"
                                aria-label="Close"
                            >
                                <i class="bi bi-x-lg fw-bold fs-t"></i>
                            </button>
                        </div>

                        <div class="offcanvas-body py-0 px-4">

                            <form className="row mt-4 mb-4">
                                <div class="">
                                    <input
                                        type="search"
                                        autoComplete={false}
                                        class="form-control form-control-lg text-dark fs-3 bg-back rounded-pill"
                                        placeholder="Search Reference"
                                        required
                                        onKeyUp={(e) => FetchNote(e.target.value)}
                                    />
                                </div>
                            </form>

                            <div className="row">

                                <div className="col-12 mb-4">
                                    <div className="card px-2 bg-back cursor-pointer shadow-none" style={{ borderRadius: "25px" }}>
                                        <div className="row d-flex align-items-center">
                                            <div className="col-4">
                                                <div className="fs-2 text-purple2 text-center">
                                                    MTH
                                                </div>
                                            </div>

                                            <div className="col-8 p-4 bg-light-primary" style={{ borderRadius: "25px" }}>
                                                <div className="fs-5 text-purple2">
                                                    Explore Mathematics notes with better user-interface, you can
                                                    ask questions, attempt exercise, set quiz test.
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 mb-4">
                                    <div className="card px-2 bg-back cursor-pointer shadow-none" style={{ borderRadius: "25px" }}>
                                        <div className="row d-flex align-items-center">
                                            <div className="col-4">
                                                <div className="fs-2 text-purple2 text-center">
                                                    ENG
                                                </div>
                                            </div>

                                            <div className="col-8 p-4 bg-light-success" style={{ borderRadius: "25px" }}>
                                                <div className="fs-5 text-purple2">
                                                    Explore English notes with better user-interface, you can
                                                    ask questions, attempt exercise, set quiz test.
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 mb-4">
                                    <div className="card px-2 bg-back cursor-pointer shadow-none" style={{ borderRadius: "25px" }}>
                                        <div className="row d-flex align-items-center">
                                            <div className="col-4">
                                                <div className="fs-2 text-purple2 text-center">
                                                    PHY
                                                </div>
                                            </div>

                                            <div className="col-8 p-4 bg-light-info" style={{ borderRadius: "25px" }}>
                                                <div className="fs-5 text-purple2">
                                                    Explore Physics notes with better user-interface, you can
                                                    ask questions, attempt exercise, set quiz test.
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 mb-4">
                                    <div className="card px-2 bg-back cursor-pointer shadow-none" style={{ borderRadius: "25px" }}>
                                        <div className="row d-flex align-items-center">
                                            <div className="col-4">
                                                <div className="fs-2 text-purple2 text-center">
                                                    CHM
                                                </div>
                                            </div>

                                            <div className="col-8 p-4 bg-light-primary" style={{ borderRadius: "25px" }}>
                                                <div className="fs-5 text-purple2">
                                                    Explore Chemistry notes with better user-interface, you can
                                                    ask questions, attempt exercise, set quiz test.
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>


                        </div>


                    </div>
                </>
            )}

        </div>
    );
};

export default Home;
